import React from 'react';
import { Tooltip } from 'antd';
import { StopOutlined } from '@ant-design/icons';

const ActDisableUser = ({ userInfo, setUserInfo, setOpenDisable }) => {
  const handleClick = () => {
    setUserInfo(userInfo);
    setOpenDisable(true);
  };

  return (
    <Tooltip title="Vô hiệu hóa">
      <StopOutlined
        onClick={handleClick}
        style={{
          fontSize: '18px',
          color: '#faad14',
          cursor: 'pointer',
          marginLeft: '8px'
        }}
      />
    </Tooltip>
  );
};

export default ActDisableUser;
